import React, { forwardRef } from 'react'
import type { HeaderCellProps } from './types'
import merge from 'lodash/merge'

export const HeaderCell = forwardRef<HTMLTableCellElement, HeaderCellProps>(({ as, style, className = '', children, field, ...rest }, ref) => {
  const As = as || 'th'
  const showField = field?.isVisible
  const fieldSize = field?.size

  //do not show the field if it defined on the config
  if (showField === false) return null

  //now we set the style
  style = merge({}, { width: fieldSize }, style)

  return (
    <As className={className} ref={ref} style={style} {...rest}>
      {children}
    </As>
  )
})
